import React from "react"
import { Button } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

export default function FormButtons({ onSave, onCancel, running, saveText, cancelText }) {

  return (
    <div className="flex justify-end items-center gap-10 flex-wrap mt-30">

      { onCancel &&
      <Button onClick={ onCancel } className="min-w-100" disabled={ running }>
        <FontAwesome name='close' /> { cancelText ? cancelText : 'Cancel'}
      </Button>}

      <Button bsStyle="success" onClick={ onSave } className="min-w-120" disabled={ running }>
        { running ? <FontAwesome name="spinner" className="animate-spin mr-3" /> : <FontAwesome name='save' /> }
        {' '} { saveText || 'Save' }
      </Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/FormButtons.js